import React, { useState, useLayoutEffect } from "react";
import SliderWrapper from "jd-library/SliderWrapper";
import ListItem from 'jd-library/ListItem';
import historyHandler from "jd-library/historyHandler";

/**
 * ListItemSlider
 * @param items - array of object like - [{key: 32323, label: 'abcd'},...]
 * @param sliderTitle - slider header title
 * @param onHidden - used by parent component, for closing the slider state
 * @param onSave - on save handler, sending data back to parent component via props
 */
const ListItemSlider = (props) => {
    const { items=[], sliderTitle='', onHidden, defaultSelectedKey=null, onSave } = props;
    const [selItem, updateselItem] = useState(null);
    
    useLayoutEffect(() => {
        if(defaultSelectedKey) {
            updateselItem(defaultSelectedKey);
        }
        // garbage collection, clearing local state on unmount
        return () => {
            updateselItem(null);
        }      
    }, []);

    /**
     * onSaveHandler - used for passing data on slider save button click
     * @param - event handler - preventing default slider wrapper behaviour
     */
    const onSaveHandler = () => {
        let selectedForm = items.find(el => el.key == selItem);
        onSave(selectedForm);
        historyHandler.closeCurrent();
    };

    return (
        <SliderWrapper
            header={{
                heading: sliderTitle
            }}
            footer={{
                btnProps: [{
                    children: 'Save',
                    onClick: () => onSaveHandler()
                }]
            }}
            onHidden={() => onHidden(false)}
        >
            {items.map((cur) => {
                return <ListItem
                    selectable={true}
                    selected={selItem == cur.key}
                    className={'pages-list-item font-14 accel3d'}
                    highlightSelected
                    middleSection={cur.label}
                    onClick={e => console.log('List Item Clicked')}
                    toggleSelected={(s) => {
                        if(s) updateselItem(cur.key);
                    }}
                />
            })}
        </SliderWrapper>
    );

}

export default ListItemSlider;
